import {
  FiHome,
  FiUsers,
  FiCheckSquare,
  FiBriefcase,
  FiFileText,
  FiFolder,
  FiTruck,
  FiSettings,
} from 'react-icons/fi';
import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/config-global';

import { Label } from 'src/components/label';
import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

const icon = (name) => (
  <span
    aria-hidden="true"
    style={{
      display: 'inline-block',
      width: 20,
      height: 20,
      flexShrink: 0,
      backgroundColor: 'currentColor',
      mask: `url(${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg) no-repeat center / contain`,
      WebkitMask: `url(${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg) no-repeat center / contain`,
    }}
  />
);

const ICONS = {
  job: icon('ic-job'),
  blog: <FiFileText size={20} aria-hidden="true" />,
  workflow: icon('ic-workflow'),
  meeting: icon('ic-meeting'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: <FiUsers size={20} aria-hidden="true" />,
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: <FiBriefcase size={20} aria-hidden="true" />,
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: <FiCheckSquare size={20} aria-hidden="true" />,
  folder: <FiFolder size={20} aria-hidden="true" />,
  course: <FiTruck size={20} aria-hidden="true" />,
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  timesheet: icon('ic-timesheet'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: <FiHome size={20} aria-hidden="true" />,
  parameter: icon('ic-parameter'),
  settings: <FiSettings size={20} aria-hidden="true" />,
  gift: icon('ic-gift'),
};

// ----------------------------------------------------------------------

export const navData = [
  /**
   * Overview
   */
  {
    subheader: 'Overview',
    items: [
      { id: 1, title: 'Home', path: paths.dashboard.root, icon: ICONS.dashboard },
      {
        id: 2,
        title: 'Team',
        path: paths.dashboard.user.list,
        icon: ICONS.user,
        // children: [
        //   { title: 'Profile', path: paths.dashboard.user.root },
        //   { title: 'Cards', path: paths.dashboard.user.cards },
        //   { title: 'List', path: paths.dashboard.user.list },
        //   { title: 'Create', path: paths.dashboard.user.new },
        //   { title: 'Edit', path: paths.dashboard.user.demo.edit },
        //   { title: 'Account', path: paths.dashboard.user.account },
        // ],
      },
      // { title: 'Tasks', path: paths.dashboard.general.ecommerce, icon: ICONS.kanban },
      { id: 3, title: 'Tasks', path: paths.dashboard.task.root, icon: ICONS.kanban },

      {
        id: 4,
        title: 'Projects',
        path: paths.dashboard.project.root,
        icon: ICONS.tour,
        // children: [
        //   { title: 'List', path: paths.dashboard.project.root },
        //   { title: 'Details', path: paths.dashboard.project.demo.details },
        //   { title: 'Create', path: paths.dashboard.project.new },
        //   { title: 'Edit', path: paths.dashboard.project.demo.edit },
        // ],
      },
      {
        id: 5,
        title: 'Documents',
        path: paths.dashboard.document.root,
        icon: ICONS.blog,
        // children: [
        //   { title: 'List', path: paths.dashboard.post.root },
        //   { title: 'Details', path: paths.dashboard.post.demo.details },
        //   { title: 'Create', path: paths.dashboard.post.new },
        //   { title: 'Edit', path: paths.dashboard.post.demo.edit },
        // ],
      },
      // { title: 'Workflow', path: paths.dashboard.general.analytics, icon: ICONS.tour },
      // { title: 'Team', path: paths.dashboard.general.banking, icon: ICONS.menuItem },
      // { title: 'Projects', path: paths.dashboard.general.booking, icon: ICONS.booking },
      // { title: 'Clients', path: paths.dashboard.general.file, icon: ICONS.file },
      { id: 6, title: 'Files', path: paths.dashboard.fileManager, icon: ICONS.folder },

      // { id: 7, title: 'Clients', path: paths.dashboard.client.root, icon: ICONS.analytics },

      { id: 8, title: 'Vendors', path: paths.dashboard.vendor.root, icon: ICONS.course },

      // {
      //   title: 'Workflow',
      //   path: paths.dashboard.order.root,
      //   icon: ICONS.workflow

      // },

      // { id: 9, title: 'Chat', path: paths.dashboard.chat, icon: ICONS.chat },

      // {
      //   id: 10,
      //   title: 'Loyalty',
      //   path: paths.dashboard.loyalty.root,
      //   icon: ICONS.gift,

      // },
      // {
      //   title: 'Meetings',
      //   path: paths.dashboard.invoice.root,
      //   icon: ICONS.meeting,
      //   // children: [
      //   //   { title: 'List', path: paths.dashboard.invoice.root },
      //   //   { title: 'Details', path: paths.dashboard.invoice.demo.details },
      //   //   { title: 'Create', path: paths.dashboard.invoice.new },
      //   //   { title: 'Edit', path: paths.dashboard.invoice.demo.edit },
      //   // ],
      // },
      // { id: 11, title: 'Calendar', path: paths.dashboard.calendar, icon: ICONS.calendar },
      // { id: 14, title: 'Timesheet', path: paths.dashboard.timesheet.root, icon: ICONS.timesheet },
      {
        id: 12,
        title: 'Settings',
        path: paths.dashboard.settings.root,
        icon: ICONS.settings,
        // children: [
        //   { title: 'List', path: paths.dashboard.settings.root },
        //   { title: 'Details', path: paths.dashboard.settings.demo.details },
        //   { title: 'Create', path: paths.dashboard.settings.new },
        //   { title: 'Edit', path: paths.dashboard.settings.demo.edit },
        // ],
      },
      // {
      //   id: 13,
      //   title: 'External Links',
      //   path: paths.dashboard.externalLink.root,
      //   icon: ICONS.external,
      // },
    ],
  },
  /**
   * Management

  {
    subheader: 'Management',
    items: [
      {
        title: 'Product',
        path: paths.dashboard.settings.root,
        icon: ICONS.product,
        children: [
          { title: 'List', path: paths.dashboard.settings.root },
          { title: 'Details', path: paths.dashboard.settings.demo.details },
          { title: 'Create', path: paths.dashboard.settings.new },
          { title: 'Edit', path: paths.dashboard.settings.demo.edit },
        ],
      },
      {
        title: 'Order',
        path: paths.dashboard.order.root,
        icon: ICONS.order,
        children: [
          { title: 'List', path: paths.dashboard.order.root },
          { title: 'Details', path: paths.dashboard.order.demo.details },
        ],
      },
      {
        title: 'Invoice',
        path: paths.dashboard.invoice.root,
        icon: ICONS.invoice,
        children: [
          { title: 'List', path: paths.dashboard.invoice.root },
          { title: 'Details', path: paths.dashboard.invoice.demo.details },
          { title: 'Create', path: paths.dashboard.invoice.new },
          { title: 'Edit', path: paths.dashboard.invoice.demo.edit },
        ],
      },
      {
        title: 'Blog',
        path: paths.dashboard.post.root,
        icon: ICONS.blog,
        children: [
          { title: 'List', path: paths.dashboard.post.root },
          { title: 'Details', path: paths.dashboard.post.demo.details },
          { title: 'Create', path: paths.dashboard.post.new },
          { title: 'Edit', path: paths.dashboard.post.demo.edit },
        ],
      },
      {
        title: 'Job',
        path: paths.dashboard.loyalty.root,
        icon: ICONS.job,
        children: [
          { title: 'List', path: paths.dashboard.loyalty.root },
          { title: 'Details', path: paths.dashboard.loyalty.demo.details },
          { title: 'Create', path: paths.dashboard.loyalty.new },
          { title: 'Edit', path: paths.dashboard.loyalty.demo.edit },
        ],
      },
      {
        title: 'Tour',
        path: paths.dashboard.project.root,
        icon: ICONS.tour,
        children: [
          { title: 'List', path: paths.dashboard.project.root },
          { title: 'Details', path: paths.dashboard.project.demo.details },
          { title: 'Create', path: paths.dashboard.project.new },
          { title: 'Edit', path: paths.dashboard.project.demo.edit },
        ],
      },
      { title: 'File manager', path: paths.dashboard.fileManager, icon: ICONS.folder },
      {
        title: 'Mail',
        path: paths.dashboard.mail,
        icon: ICONS.mail,
        info: (
          <Label color="error" variant="inverted">
            +32
          </Label>
        ),
      },
      { title: 'Chat', path: paths.dashboard.chat, icon: ICONS.chat },
      { title: 'Calendar', path: paths.dashboard.calendar, icon: ICONS.calendar },
      { title: 'Kanban', path: paths.dashboard.kanban, icon: ICONS.kanban },
    ],
  },
  /**
   * Item State

  {
    subheader: 'Misc',
    items: [
      {
        // default roles : All roles can see this entry.
        // roles: ['user'] Only users can see this item.
        // roles: ['admin'] Only admin can see this item.
        // roles: ['admin', 'manager'] Only admin/manager can see this item.
        // Reference from 'src/guards/RoleBasedGuard'.
        title: 'Permission',
        path: paths.dashboard.permission,
        icon: ICONS.lock,
        roles: ['admin', 'manager'],
        caption: 'Only admin can see this item',
      },
      {
        title: 'Level',
        path: '#/dashboard/menu_level',
        icon: ICONS.menuItem,
        children: [
          {
            title: 'Level 1a',
            path: '#/dashboard/menu_level/menu_level_1a',
            children: [
              {
                title: 'Level 2a',
                path: '#/dashboard/menu_level/menu_level_1a/menu_level_2a',
              },
              {
                title: 'Level 2b',
                path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b',
                children: [
                  {
                    title: 'Level 3a',
                    path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b/menu_level_3a',
                  },
                  {
                    title: 'Level 3b',
                    path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b/menu_level_3b',
                  },
                ],
              },
            ],
          },
          { title: 'Level 1b', path: '#/dashboard/menu_level/menu_level_1b' },
        ],
      },
      {
        title: 'Disabled',
        path: '#disabled',
        icon: ICONS.disabled,
        disabled: true,
      },
      {
        title: 'Label',
        path: '#label',
        icon: ICONS.label,
        info: (
          <Label
            color="info"
            variant="inverted"
            startIcon={<Iconify icon="solar:bell-bing-bold-duotone" />}
          >
            NEW
          </Label>
        ),
      },
      {
        title: 'Caption',
        path: '#caption',
        icon: ICONS.menuItem,
        caption:
          'Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.',
      },
      {
        title: 'Params',
        path: '/dashboard/params?id=e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1',
        icon: ICONS.parameter,
      },
      {
        title: 'External link',
        path: 'https://www.google.com/',
        icon: ICONS.external,
        info: <Iconify width={18} icon="prime:external-link" />,
      },
      { title: 'Blank', path: paths.dashboard.blank, icon: ICONS.blank },
    ],
  },
  */
];

export const forRestrictedNavsnavData = [
  /**
   * Overview
   */
  {
    subheader: 'Overview',
    items: [
      { id: 1, title: 'Home', path: paths.dashboard.root, icon: ICONS.dashboard },
      {
        id: 2,
        title: 'Team',
        path: paths.dashboard.user.list,
        icon: ICONS.user,
        // children: [
        //   { title: 'Profile', path: paths.dashboard.user.root },
        //   { title: 'Cards', path: paths.dashboard.user.cards },
        //   { title: 'List', path: paths.dashboard.user.list },
        //   { title: 'Create', path: paths.dashboard.user.new },
        //   { title: 'Edit', path: paths.dashboard.user.demo.edit },
        //   { title: 'Account', path: paths.dashboard.user.account },
        // ],
      },
      // { title: 'Tasks', path: paths.dashboard.general.ecommerce, icon: ICONS.kanban },
      { id: 3, title: 'Tasks', path: paths.dashboard.task.root, icon: ICONS.kanban },

      {
        id: 4,
        title: 'Projects',
        path: paths.dashboard.project.root,
        icon: ICONS.tour,
        // children: [
        //   { title: 'List', path: paths.dashboard.project.root },
        //   { title: 'Details', path: paths.dashboard.project.demo.details },
        //   { title: 'Create', path: paths.dashboard.project.new },
        //   { title: 'Edit', path: paths.dashboard.project.demo.edit },
        // ],
      },
      {
        id: 5,
        title: 'Documents',
        path: paths.dashboard.document.root,
        icon: ICONS.blog,
        // children: [
        //   { title: 'List', path: paths.dashboard.post.root },
        //   { title: 'Details', path: paths.dashboard.post.demo.details },
        //   { title: 'Create', path: paths.dashboard.post.new },
        //   { title: 'Edit', path: paths.dashboard.post.demo.edit },
        // ],
      },
      // { title: 'Workflow', path: paths.dashboard.general.analytics, icon: ICONS.tour },
      // { title: 'Team', path: paths.dashboard.general.banking, icon: ICONS.menuItem },
      // { title: 'Projects', path: paths.dashboard.general.booking, icon: ICONS.booking },
      // { title: 'Clients', path: paths.dashboard.general.file, icon: ICONS.file },
      { id: 6, title: 'Files', path: paths.dashboard.fileManager, icon: ICONS.folder },

      { id: 7, title: 'Clients', path: paths.dashboard.client.root, icon: ICONS.analytics },

      { id: 8, title: 'Vendors', path: paths.dashboard.vendor.root, icon: ICONS.course },

      // {
      //   title: 'Workflow',
      //   path: paths.dashboard.order.root,
      //   icon: ICONS.workflow

      // },

      { id: 9, title: 'Chat', path: paths.dashboard.chat, icon: ICONS.chat },

      {
        id: 10,
        title: 'Loyalty',
        path: paths.dashboard.loyalty.root,
        icon: ICONS.gift,
        // children: [
        //   { title: 'List', path: paths.dashboard.loyalty.root },
        //   { title: 'Details', path: paths.dashboard.loyalty.demo.details },
        //   { title: 'Create', path: paths.dashboard.loyalty.new },
        //   { title: 'Edit', path: paths.dashboard.loyalty.demo.edit },
        // ],
      },
      // {
      //   title: 'Meetings',
      //   path: paths.dashboard.invoice.root,
      //   icon: ICONS.meeting,
      //   // children: [
      //   //   { title: 'List', path: paths.dashboard.invoice.root },
      //   //   { title: 'Details', path: paths.dashboard.invoice.demo.details },
      //   //   { title: 'Create', path: paths.dashboard.invoice.new },
      //   //   { title: 'Edit', path: paths.dashboard.invoice.demo.edit },
      //   // ],
      // },
      { id: 11, title: 'Calendar', path: paths.dashboard.calendar, icon: ICONS.calendar },
      { id: 14, title: 'Timesheet', path: paths.dashboard.timesheet.root, icon: ICONS.timesheet },
      {
        id: 12,
        title: 'Settings',
        path: paths.dashboard.settings.root,
        icon: ICONS.settings,
        // children: [
        //   { title: 'List', path: paths.dashboard.settings.root },
        //   { title: 'Details', path: paths.dashboard.settings.demo.details },
        //   { title: 'Create', path: paths.dashboard.settings.new },
        //   { title: 'Edit', path: paths.dashboard.settings.demo.edit },
        // ],
      },
      {
        id: 13,
        title: 'External Links',
        path: paths.dashboard.externalLink.root,
        icon: ICONS.external,
      },
    ],
  },
  /**
   * Management

  {
    subheader: 'Management',
    items: [
      {
        title: 'Product',
        path: paths.dashboard.settings.root,
        icon: ICONS.product,
        children: [
          { title: 'List', path: paths.dashboard.settings.root },
          { title: 'Details', path: paths.dashboard.settings.demo.details },
          { title: 'Create', path: paths.dashboard.settings.new },
          { title: 'Edit', path: paths.dashboard.settings.demo.edit },
        ],
      },
      {
        title: 'Order',
        path: paths.dashboard.order.root,
        icon: ICONS.order,
        children: [
          { title: 'List', path: paths.dashboard.order.root },
          { title: 'Details', path: paths.dashboard.order.demo.details },
        ],
      },
      {
        title: 'Invoice',
        path: paths.dashboard.invoice.root,
        icon: ICONS.invoice,
        children: [
          { title: 'List', path: paths.dashboard.invoice.root },
          { title: 'Details', path: paths.dashboard.invoice.demo.details },
          { title: 'Create', path: paths.dashboard.invoice.new },
          { title: 'Edit', path: paths.dashboard.invoice.demo.edit },
        ],
      },
      {
        title: 'Blog',
        path: paths.dashboard.post.root,
        icon: ICONS.blog,
        children: [
          { title: 'List', path: paths.dashboard.post.root },
          { title: 'Details', path: paths.dashboard.post.demo.details },
          { title: 'Create', path: paths.dashboard.post.new },
          { title: 'Edit', path: paths.dashboard.post.demo.edit },
        ],
      },
      {
        title: 'Job',
        path: paths.dashboard.loyalty.root,
        icon: ICONS.job,
        children: [
          { title: 'List', path: paths.dashboard.loyalty.root },
          { title: 'Details', path: paths.dashboard.loyalty.demo.details },
          { title: 'Create', path: paths.dashboard.loyalty.new },
          { title: 'Edit', path: paths.dashboard.loyalty.demo.edit },
        ],
      },
      {
        title: 'Tour',
        path: paths.dashboard.project.root,
        icon: ICONS.tour,
        children: [
          { title: 'List', path: paths.dashboard.project.root },
          { title: 'Details', path: paths.dashboard.project.demo.details },
          { title: 'Create', path: paths.dashboard.project.new },
          { title: 'Edit', path: paths.dashboard.project.demo.edit },
        ],
      },
      { title: 'File manager', path: paths.dashboard.fileManager, icon: ICONS.folder },
      {
        title: 'Mail',
        path: paths.dashboard.mail,
        icon: ICONS.mail,
        info: (
          <Label color="error" variant="inverted">
            +32
          </Label>
        ),
      },
      { title: 'Chat', path: paths.dashboard.chat, icon: ICONS.chat },
      { title: 'Calendar', path: paths.dashboard.calendar, icon: ICONS.calendar },
      { title: 'Kanban', path: paths.dashboard.kanban, icon: ICONS.kanban },
    ],
  },
  /**
   * Item State

  {
    subheader: 'Misc',
    items: [
      {
        // default roles : All roles can see this entry.
        // roles: ['user'] Only users can see this item.
        // roles: ['admin'] Only admin can see this item.
        // roles: ['admin', 'manager'] Only admin/manager can see this item.
        // Reference from 'src/guards/RoleBasedGuard'.
        title: 'Permission',
        path: paths.dashboard.permission,
        icon: ICONS.lock,
        roles: ['admin', 'manager'],
        caption: 'Only admin can see this item',
      },
      {
        title: 'Level',
        path: '#/dashboard/menu_level',
        icon: ICONS.menuItem,
        children: [
          {
            title: 'Level 1a',
            path: '#/dashboard/menu_level/menu_level_1a',
            children: [
              {
                title: 'Level 2a',
                path: '#/dashboard/menu_level/menu_level_1a/menu_level_2a',
              },
              {
                title: 'Level 2b',
                path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b',
                children: [
                  {
                    title: 'Level 3a',
                    path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b/menu_level_3a',
                  },
                  {
                    title: 'Level 3b',
                    path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b/menu_level_3b',
                  },
                ],
              },
            ],
          },
          { title: 'Level 1b', path: '#/dashboard/menu_level/menu_level_1b' },
        ],
      },
      {
        title: 'Disabled',
        path: '#disabled',
        icon: ICONS.disabled,
        disabled: true,
      },
      {
        title: 'Label',
        path: '#label',
        icon: ICONS.label,
        info: (
          <Label
            color="info"
            variant="inverted"
            startIcon={<Iconify icon="solar:bell-bing-bold-duotone" />}
          >
            NEW
          </Label>
        ),
      },
      {
        title: 'Caption',
        path: '#caption',
        icon: ICONS.menuItem,
        caption:
          'Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.',
      },
      {
        title: 'Params',
        path: '/dashboard/params?id=e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1',
        icon: ICONS.parameter,
      },
      {
        title: 'External link',
        path: 'https://www.google.com/',
        icon: ICONS.external,
        info: <Iconify width={18} icon="prime:external-link" />,
      },
      { title: 'Blank', path: paths.dashboard.blank, icon: ICONS.blank },
    ],
  },
  */
];

export const manualnonrestrictedpaths = ['/dashboard/document/new', '/dashboard/task/new'];
